import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiService } from '../../services/api';

/**
 * Email ownership-verification landing page. Reads ?token from the link we emailed, confirms it, and
 * shows the result. On success the account's email is marked verified (users.is_verified).
 */
const VerifyEmail: React.FC = () => {
  const navigate = useNavigate();
  const [state, setState] = useState<'verifying' | 'ok' | 'error'>('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token') || '';
    if (!token) { setState('error'); setMessage('This link is missing its verification token.'); return; }
    apiService.verifyEmailToken(token)
      .then(() => { setState('ok'); setMessage('Your email is verified. Thank you!'); })
      .catch((e) => { setState('error'); setMessage(e instanceof Error ? e.message : 'This link is invalid or has expired.'); });
  }, []);

  return (
    <div style={S.wrap}>
      <div style={S.card}>
        <div style={{ ...S.icon, ...(state === 'ok' ? S.iconOk : state === 'error' ? S.iconErr : {}) }}>
          {state === 'verifying' ? '…' : state === 'ok' ? '✓' : '!'}
        </div>
        <h1 style={S.title}>{state === 'verifying' ? 'Verifying your email…' : state === 'ok' ? 'Email verified' : "Couldn't verify"}</h1>
        <p style={S.msg}>{message}</p>
        <div style={S.actions}>
          <button style={S.primary} onClick={() => navigate('/')}>Go to app</button>
          {state === 'error' && <Link to="/profile" style={S.link}>Open profile</Link>}
        </div>
      </div>
    </div>
  );
};

const S: Record<string, React.CSSProperties> = {
  wrap: { minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  card: { width: 'min(420px, 100%)', textAlign: 'center', background: '#0D1F3C', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 16, padding: 28, color: '#F5F5F0' },
  icon: { width: 56, height: 56, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, fontWeight: 800, background: 'rgba(255,255,255,0.08)', margin: '0 auto 14px' },
  iconOk: { background: 'rgba(168,255,62,0.15)', color: '#A8FF3E' },
  iconErr: { background: 'rgba(255,59,59,0.15)', color: '#FF3B3B' },
  title: { fontSize: '1.3rem', fontWeight: 800, margin: '0 0 8px' },
  msg: { color: 'rgba(245,245,240,0.7)', fontSize: '0.95rem', lineHeight: 1.55, margin: '0 0 20px' },
  actions: { display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center' },
  primary: { background: '#FF6B35', color: '#fff', border: 'none', borderRadius: 10, padding: '11px 20px', fontWeight: 800, cursor: 'pointer', width: '100%' },
  link: { color: '#00D4FF', textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem' },
};

export default VerifyEmail;
